import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=1e183bc8"
import script from "./Voice.vue?vue&type=script&lang=js"
export * from "./Voice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports